// 삼성 에스원
export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace",
        name: "직영사업장",
        icon: "w-line",
        activeCode: "field-workplace",
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가 Tool(3단계 판단법)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/587",
        name: "위험성평가 사전회의일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["587"],
      },
      {
        url: "/tab/584",
        name: "정기 위험성평가(3단계법)",
        icon: "w-line",
        activeCode: "",
        groupName: ["584"],
      },
      {
        url: "/tab/588",
        name: "정기 위험성평가 교육 일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["588"],
      },
      {
        url: "/tab/589",
        name: "수시 위험성평가(OPS)",
        icon: "w-line",
        activeCode: "",
        groupName: ["589"],
      },
      {
        url: "/tab/590",
        name: "수시 위험성평가 교육 일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["590"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가 실시 자료(빈도 강도법)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/591",
        name: "위험성평가 대상",
        icon: "w-line",
        activeCode: "",
        groupName: ["591"],
      },
      {
        url: "/tab/583",
        name: "유해·위험요인 분류표",
        icon: "w-line",
        activeCode: "",
        groupName: ["583"],
      },
      {
        url: "/tab/592",
        name: "위험성 결정",
        icon: "w-line",
        activeCode: "",
        groupName: ["592"],
      },
      {
        url: "/tab/596",
        name: "위험성 결과",
        icon: "w-line",
        activeCode: "",
        groupName: ["596"],
      },
      {
        url: "/tab/595",
        name: "감소대책 수립 및 실행",
        icon: "w-line",
        activeCode: "",
        groupName: ["595"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 파악 조사표",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/582",
        name: "관리자(사업장 순회점검)",
        icon: "w-line",
        activeCode: "",
        groupName: ["582"],
      },
      {
        url: "/tab/581",
        name: "근로자(상시제안 및 청취조사)",
        icon: "w-line",
        activeCode: "",
        groupName: ["581"],
      },
    ],
  },
];
